import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PageMoreComponent } from '@app/views/page-more/page-more.component';
import { PagePdfMenuComponent } from '@app/views/page-pdf-menu/page-pdf-menu.component';
import { PageSpecialsComponent } from '@app/views/page-specials/page-specials.component';
import { PageServiceCentreComponent } from '@app/views/page-service-centre/page-service-centre.component';
import { PageSchema } from '@app/schemas/page';
import { PageBuilderComponent } from '@app/views/page-builder/page-builder.component';
import { PageService } from '@app/services/page';
import { selectCurrentPage } from './dynamic-page';

@Component({
  selector: 'app-page-dynamic',
  templateUrl: './dynamic.component.html',
  styleUrl: './dynamic.component.scss',
  imports: [
    PageMoreComponent,
    PagePdfMenuComponent,
    PageSpecialsComponent,
    PageServiceCentreComponent,
    PageBuilderComponent,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicComponent {

  private readonly pages = toSignal(inject(PageService).config$);
  public readonly page = input.required<PageSchema>();

  protected readonly currentPage = computed(() => selectCurrentPage(this.page(), this.pages()));

}
